<template>
    <div class=".container-fluid  full-height">
        <NavBar></NavBar>
                
                <div class="d-flex justify-content-center" >

                     <div class="embossedContainerWithRoundedCorners" style="width:500px">

                        <img src="@/assets/unk_logo.png" class="iconDetails">

                        <div class="brandName">                    
                            <h2>{{ AppTitle }} </h2>
                        </div>

                        <form novalidate @submit.prevent="login" style="padding:0px">

                            <div class="alert alert-danger alert-dismissible fade show" role="alert" v-for="msg in errors" :key="msg" >
                                {{msg}}                                
                            </div>

                             <div class="form-group">
                                <label for="email">Email </label>
                                <input class="form-control" id="email"  v-model="email"  type="email">
                            </div>

                            <div class="form-group">
                                <label for="password">Password </label>
                                <input class="form-control" id="password"  v-model="password"  type="password">
                            </div>

                            <div class="forgotPasswordLink" mt-0>
                                <router-link  to="forgotpassword">Forgot password?</router-link>                        
                            </div>

                            <div class="rememberMe">
                                <div class="form-check">
                                    <input type="checkbox" class="form-check-input" id="rememberMe" v-model="rememberMe">
                                    <label class="form-check-label" for="rememberMe" >Remember Me</label>
                                </div>                       
                            </div>

                            <div class="signInRow pb-10 ">
                                <button type="submit" class="btn btn-primary loginBtn"  :disabled="this.isLoading">
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="this.isLoading"></span>
                                    Login</button>
                            </div>

                        </form>

                    </div>
                </div>

        <Footer class="footerStickedToBottom" ></Footer>        

    </div>
                    
</template>

<script>

import {AppTitle} from '@/Globals'
import NavBar  from '@/components/NavBar';
import { Auth } from '@/firebase/auth';
import { DB } from '@/firebase/db';

export default {
  name: 'login',
  components: {
      NavBar
  },
  data() {
    return {
      email: '',
      password: '',
      rememberMe: true,

      errors: [],
      AppTitle,
      isLoading :false,
      
    };
  },
  props:{
      action:String
  },
  methods: {
    async login() {

        this.errors = [];

        if (this.email == '') {
            this.errors.push('Email is mandatory');
        }
        if (this.password == '') {
            this.errors.push('Password is mandatory');
        }

        
        if (!this.errors.length) {

            this.isLoading = true;
            const _this = this;

            Auth.signInWithEmailAndPassword(this.email, this.password)
            .then(async ()=>{
                DB.collection("users").
                where('email', '==', _this.email)
                .get()
                .then((querySnapshot) => {

                    if(querySnapshot.size == 0){
                        const errMsg = "Error: Account information is incomplete. Please delete the existing account and recreate";
                        _this.errors.push(errMsg);
                        _this.isLoading = false;
                    }

                    querySnapshot.forEach((doc) => { 

                            var userInfo = {     
                                id: doc.data().id,
                                name: doc.data().name,
                                email: doc.data().email,
                                role: doc.data().role,
                                rememberMe: _this.rememberMe,
                                createdBy: doc.data().createdBy,              
                                createdAt: doc.data().createdAt,
                                modifiedBy: doc.data().modifiedBy,
                                modifiedAt: doc.data().modifiedAt,
                            };


                            _this.isLoading = false;
                            _this.$store.commit('login', userInfo);
                            _this.$router.push('/');

                            
                    });
              
                })
                .catch((err) => {
                    var errMsg = err.message;
                    if("Failed to get document because the client is offline." == err.message){
                        errMsg = "Failed to connect. Pls check your internet connection!";
                    }else{
                        errMsg = "Invalid Credentials"
                    }
                    _this.errors.push(errMsg);
                    _this.isLoading = false;
                }); 

               
                
            })
            .catch(err => {
                var errMsg = err.message;
                if("Failed to get document because the client is offline." == err.message){
                    errMsg = "Failed to connect. Pls check your internet connection!";
                }else{
                    errMsg = "Invalid Credentials"
                }
                _this.errors.push(errMsg);
                _this.isLoading = false;
            });
            
        }

    },
  },
};
</script>

<style lang="scss">
body{
    background: #e6ecf1;    
}

#app .brandName {
    margin-top: 20px;
    margin-bottom: 50px;
}


#app .signUpRow {
  text-align: center;
  margin: 20px;
}

#app .signUpNewUserText {
  display: inline-block;
}

#app .forgotPasswordLink {
  float: right;
}

#app .rememberMe {
  float: left;
}

#app .signInRow {
    margin-top: 60px;
    margin-bottom: 10px;
}


#app .iconDetails {
height:40px;
width:40px; 
margin-top: 20px;
}

#app .loginBtn {
    padding-left: 50px;
    padding-right: 50px;
}

#app .bg-theme{
    background: #e6ecf1;
}
</style>